import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UserTerm } from '../../models/domains/user-term/user-term.model';
@Injectable({
    providedIn: 'root'
})

export class UserTermObserverService {
    obsUserTerm: BehaviorSubject<UserTerm> = new BehaviorSubject<UserTerm | null>(null);

    changeUserTerm(data: UserTerm) {
        this.obsUserTerm.next(data);
    }
}